<template>
  <div class="container">
    <div class="row header">
      <div class="title">新闻分类统计</div>
      <sn-tabs :tabs="tabs" @change="onTabChange"></sn-tabs>
    </div>
    <div class="body" v-loading="isLoading">
      <div class="bar-container" v-for="(item, index) in data" :key="index">
        <div class="bar-header">
          <span class="count">{{item.count}}<span class="count-title">条</span></span>
          <span class="category" @click="showCategoryDetail(item.id, item.category, item.sentiment)">{{item.category}}</span>
        </div>
        <horizontal-bar class="bar" :width="item.width" :height="4" :sentiment="item.sentiment"></horizontal-bar>
      </div>
      <img v-if="!data.length" class="entity-news-no-data-img" src="../../assets/img/entity-news-no-data.svg" alt /> 
      <div v-if="!data.length" class="entity-news-no-data">{{dataTypeData}}没有舆情数据</div>     
    </div>
    <EntityNewsStatisticsDialog :dateType="dateType" :searchText="searchText" :category="category" :negative="params.negative" :positive="params.positive"  @closeTodayCompanyDialog="dialogVisible = false" v-if="dialogVisible"></EntityNewsStatisticsDialog>
  </div>
</template>

<script>
import HorizontalBar from '@/components/common/HorizontalBar';
import EntityNewsStatisticsDialog from '@/components/news-monitor/EntityNewsStatisticsDialog';
import SnTabs from '@/components/common/SnTabs';
import QuestionQuery from '@/rest/questionQuery';
import dateHelper from '@/helpers/dateHelper';

export default {
  props: {
    searchText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      category: '',
      totalCount: 0,
      dialogVisible: false,
      tabs: ['近一周', '近一月', '近三月'],
      dateType: 'week',
      dataTypeData: '近一周',
      dateRange: [],
      data: [],
      isLoading: false,
      currentPage: 1,
      pageSize: 15,
      params: {
        negative: [],
        positive: [],
        pageNum: 1,
        pageSize: 15,
        companyName: '',
        market: '全部',
        source: '全部来源',
        dateType: ''
      },
      resultData: [],
      showClues: true
    };
  },
  methods: {
    onTabChange({ item }) {
      dateHelper.formatDate();
      if (item === '近一周') {
        this.dateType = 'week';
        this.dataTypeData = '近一周';
      } else if (item === '近一月') {
        this.dateType = 'month';
        this.dataTypeData = '近一月';
      } else if (item === '近三月') {  
        this.dateType = 'threeMonth';
        this.dataTypeData = '近三月';
      }
      this.requestForData(this.searchText, this.dateType);
    },
    requestForData(searchText, dateType) {
      this.isLoading = true;
      this.currentPage = 1;
      this.params.pageNum = 1;
      this.data = []; // clean up data
      QuestionQuery.getEntityNewsStatistics(searchText, dateType).then(data => {
        this.isLoading = false;
        const MAX_WIDTH = 320;
        this.data = data.data;
        if (data.length) {
          const ratio = MAX_WIDTH / data[0].number;
          this.data = data.map(item => {
            return {
              count: item.number,
              width: item.number * ratio,
              category: item.name,
              sentiment: item.type,
              id: item.id
            };
          });
        } else {
          this.data = [];
        }
      });
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.params.pageNum = page;
      this.requestNewsList();
    },
    showCategoryDetail(id, category, sentiment) {
      this.category = category;
      this.params.negative = [];
      this.params.positive = [];
      this.params[sentiment] = [id];
      this.dialogVisible = true;
    },
    requestNewsList() {
      this.isLoading = true;
      this.rerender = false;
      this.resultData = [];
      this.totalCount = 0;
      this.params.companyName = this.searchText;
      this.params.dateType = this.dateType;
      QuestionQuery.getCompanyRiskNewsListV2(this.params).then(res => {
        this.isLoading = false;
        this.rerender = true;
        this.resultData = res.result;
        this.totalCount = res.totalCount;
      });
    },
    handleClose() {
      this.params = {
        negative: [],
        positive: [],
        pageNum: 1,
        pageSize: 15,
        companyName: '',
        market: '全部',
        source: '全部来源',
        dateType: ''
      };
      this.dialogVisible = false;
    }
  },
  watch: {
    searchText(newVal, oldVal) { 
      if (oldVal !== '') {
        this.requestForData(this.searchText, this.dateType);  
      }         
    },
    dialogVisible(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  },
  mounted() {
    this.dateRange = dateHelper.formatDate('week');
    this.requestForData(this.searchText, this.dateType);
  },
  components: {
    HorizontalBar,
    SnTabs,
    EntityNewsStatisticsDialog
  }
};
</script>


<style lang="scss" scoped>
.container {
  width: 100%;
  height: 338px;
  padding: 16px;
  background-color: #ffffff;
  color: #171f46;
  & > .header {
    justify-content: space-between;
  }
  .body {
    position: relative;
    overflow: auto;
    margin-top: 14px;
    height: 268px;
    .entity-news-no-data-img {
      position: absolute;
      top: 78px;
      left: 50%;
      transform: translateX(-50%);
    }
    .entity-news-no-data {
      position: absolute;
      top: 170px;
      left: 50%;
      transform: translateX(-50%);
    }
    .bar-container {
      margin-top: 12px;
      .bar-header {
        .count {
          font-size: 16px;
          font-family: DIN-Bold;
          color: #464d6c;
          .count-title {
            color: #747990;
            font-size: 12px;
          }
        }
        .category {
          margin-left: 16px;
          color: #464d6c;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .bar {
        margin-top: 4px;
      }
    }
  }
  .news-dialog {
    &_title {
      height: 44px;
      line-height: 44px;
      padding-left: 24px;
      font-size: 14px;
      color:rgba(23,31,70,1);
      font-weight:500;
      box-shadow:0px 1px 0px 0px rgba(247,247,250,1);
    }
    .news-list-box {
      padding: 0 32px;
      height: 500px;
      overflow-y: auto;
      .no-data-container {
        height: 500px;
      }
      .title{
        font-size:16px;
        font-weight:500;
        color:rgba(23,31,70,1);
      }
    }
    /deep/ .el-dialog__wrapper {
      .el-dialog {
        width: 814px;
        position: relative;
        margin-top: 19vh !important;
        border-radius: 4px !important;
        box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.2) !important;
        border: none;
        overflow: hidden;
        .el-dialog__header {
          position: absolute;
          top: 0;
          right: 0px;
          .el-dialog__headerbtn {
            width: 24px;
            height: 24px;
            top: 14px;
            .el-dialog__close {
              color: #514d4f;
            }
          }
        }
        .el-dialog__body {
          background: #ffffff;
          padding: 0;
          .search-news-list-container {
            .filter {
              height: 54px;
              justify-content: center;
              span {
                display: none;
              }
              div{
                display: none;
              }
              border-bottom: 1px solid #4E4A4D;
              padding-bottom: 22px;
            }
            .result-container {
            height: 440px;
            overflow-y: auto;
            margin-top: 0;
            }
          }
        }
      }
    }
  }
}
/deep/ .news-item-container .news-item-container-title .title-related-news{
  width: 470px !important;
}
.pager {
  height: 80px;
  display: flex;
  align-items: center;
  & /deep/ {
    .el-pagination{
      .btn-prev,
      .btn-next,
      .el-pager .number,
      .el-pager li.btn-quicknext,
      .el-pager li.btn-quickprev,
      .el-icon-more .el-icon-d-arrow-right{
        border-radius:2px;
        border:1px solid rgba(229,230,238,1);
        background: #ffffff;
        min-width: 22px !important;
        height: 22px;
        line-height: 22px;
        font-size: 12px;
      }
      .active{
        border: none;
      }
      .more::before {
        line-height: 22px;
      }
      .el-pagination__jump{
        color: #747990;
        line-height: 22px;
      }
    }
    .el-pagination__editor.el-input .el-input__inner {
      height: 22px;
    }
  }
}
/deep/ .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  height: 32px;
  color: #fff;
}
/deep/ .el-pagination__editor.el-input {
  .el-input__inner {
     width:46px;
     height:22px;
          background:rgba(247,248,252,1);
          border-radius:2px;
          border:none;
    color: #7A757B;
    border-radius: 4px !important;
  }
}

.loading {  
  min-height: 500px;
}

.item-loading {
  padding: 12px 0;
  height: 10px;
  width: 772px;
  color: #ffffff99;
  text-align: center;
}
</style>

